import React, { useEffect, useState } from 'react';
import { api } from '../../api/client';
import ExternalUserDetailModal from './ExternalUserDetailModal';
import ExternalUserFormModal from './ExternalUserFormModal';
import Pagination from './Pagination';
import usePageSize from '../../utils/usePageSize';

import { ta } from '../../i18n/adminT';
export default function ExternalUsersManager() {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const { pageSize, pageSizeRef, setPageSize } = usePageSize('external-users');
  const [search, setSearch] = useState('');
  const [detailUser, setDetailUser] = useState(null);
  // undefined = popup chiuso, null = nuovo utente, oggetto = modifica
  const [formUser, setFormUser] = useState(undefined);

  const load = async (q = search, p = page) => {
    const res = await api.getExternalUsers(q, p, pageSizeRef.current);
    // Eliminata l'ultima riga dell'ultima pagina: si torna alla precedente
    if (res.data.length === 0 && p > 1 && res.total > 0) {
      return load(q, p - 1);
    }
    setUsers(res.data);
    setTotal(res.total);
    setPage(p);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load('', 1); }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    load(search, 1);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    load(search, 1);
  };

  const handleDelete = async (id) => {
    if (!window.confirm(ta('Eliminare questo utente esterno? Le registrazioni già effettuate resteranno nello storico.'))) return;
    await api.deleteExternalUser(id);
    await load();
  };

  return (
    <div>
      <h1 className="admin-page-title">{ta('Utenti esterni')}</h1>
      <p className="admin-page-subtitle">
        {ta('Persone o ditte esterne che si registrano spesso: associa un badge NFC (o usa il codice di riserva) per farle registrare in autonomia con il tasto "Badge".')}
      </p>

      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginBottom: 18 }}>
        <form onSubmit={handleSearch}>
          <input className="search-input" placeholder={ta('Cerca per nome, cognome o ditta…')} value={search} onChange={(e) => setSearch(e.target.value)} style={{ width: 280 }} />
        </form>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => setFormUser(null)}
          style={{ width: 'auto', padding: '10px 20px', marginTop: 0 }}
        >
          {ta('+ Aggiungi nuovo')}
        </button>
      </div>

      <div className="admin-card">
        <table className="admin-table">
          <thead>
            <tr>
              <th>{ta('Nome')}</th>
              <th>{ta('Cognome')}</th>
              <th>{ta('Ditta')}</th>
              <th>{ta('Numero badge')}</th>
              <th>{ta('Codice di riserva')}</th>
              <th>{ta('Email')}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>
                  <button type="button" className="link-button" onClick={() => setDetailUser(u)} title={ta('Vedi tutti i dati')}>
                    {u.nome}
                  </button>
                </td>
                <td>
                  <button type="button" className="link-button" onClick={() => setDetailUser(u)} title={ta('Vedi tutti i dati')}>
                    {u.cognome}
                  </button>
                </td>
                <td>{u.ditta}</td>
                <td className="mono">{u.nfc_uid || <span style={{ color: 'var(--muted-text)' }}>{ta('non associato')}</span>}</td>
                <td className="mono">{u.unique_code}</td>
                <td>{u.email || <span style={{ color: 'var(--muted-text)' }}>—</span>}</td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="btn-ghost btn" style={{ width: 'auto', padding: '6px 10px' }} onClick={() => setFormUser(u)}>{ta('Modifica')}</button>
                  <button className="btn-ghost btn" style={{ width: 'auto', padding: '6px 10px' }} onClick={() => handleDelete(u.id)}>{ta('Elimina')}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && <p style={{ color: 'var(--muted-text)', padding: '16px 0 0' }}>{ta('Nessun utente esterno registrato.')}</p>}

        <Pagination
          page={page}
          totalPages={Math.max(1, Math.ceil(total / pageSize))}
          onChange={(p) => load(search, p)}
          total={total}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
        />
      </div>

      {detailUser && (
        <ExternalUserDetailModal
          user={detailUser}
          onClose={() => setDetailUser(null)}
          onRegenerated={load}
        />
      )}

      {formUser !== undefined && (
        <ExternalUserFormModal
          user={formUser}
          onClose={() => setFormUser(undefined)}
          onSaved={load}
        />
      )}
    </div>
  );
}
